import { useEffect, useState } from "react";
import { Activity } from "lucide-react";
import tr from "@/i18n/tr";
import api from "@/lib/api";

export default function ActivityFeed() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/audit-logs", { params: { page_size: 8 } });
                setItems(data.items || []);
            } catch { setItems([]); }
            finally { setLoading(false); }
        })();
    }, []);
    return (
        <div className="card-elevated p-5">
            <div className="flex items-start justify-between mb-4">
                <div>
                    <div className="text-[13px] font-semibold text-foreground">{tr.dashboard.stats.recentActivities}</div>
                    <div className="text-[11.5px] text-muted-foreground mt-0.5">Son 24 saat</div>
                </div>
            </div>
            {loading ? (
                <div className="text-[12px] text-muted-foreground py-6 text-center">Yükleniyor…</div>
            ) : items.length === 0 ? (
                <div className="text-center py-8 text-muted-foreground">
                    <Activity className="h-8 w-8 mx-auto mb-2 opacity-30" />
                    <div className="text-[12.5px]">Henüz aktivite yok.</div>
                </div>
            ) : (
                <ul className="space-y-1">
                    {items.slice(0, 6).map((it) => (
                        <li key={it.id} className="flex items-start gap-3 rounded-xl px-2 py-2 hover:bg-muted/60 transition-colors">
                            <div className="mt-0.5 flex h-8 w-8 items-center justify-center rounded-lg bg-[hsl(var(--brand))]/10 text-[hsl(var(--brand))]">
                                <Activity className="h-4 w-4" />
                            </div>
                            <div className="min-w-0 flex-1">
                                <div className="text-[12.5px] font-semibold text-foreground truncate">{it.action} · {it.module}</div>
                                <div className="text-[11.5px] text-muted-foreground truncate">{it.user_name || "Sistem"}</div>
                            </div>
                            <div className="text-[11px] text-muted-foreground shrink-0">{it.at ? new Date(it.at).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" }) : ""}</div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
